import styled from "styled-components";

import { Spinner } from "/component/base";

export const LoadMoreSpinner = styled(Spinner)(({ theme }) => ({
  display: "block",
  // TODO: use `<Loading variant="infinite-scroll" />` once #55 is merged
  margin: `${theme.spacing.expanded}px auto 0`,
}));
